import { subscribe } from 'valtio';

export const climateInfoGraphKeys = new Set([
  'climate_sample_indices',
  'humidity_graph',
  'temp_graph'
]);

export const rootZoneInfoGraphKeys = new Set([
  'root_zone_sample_indices',
  'vol_water_content_graphs',
  'ec_root_zone_graphs',
  'info_graph_source_sample_count',
  'info_graph_sample_interval_seconds'
]);

export const infoGraphKeys = new Set([
  ...climateInfoGraphKeys,
  ...rootZoneInfoGraphKeys
]);

export function includesInfoGraphChange(operations, keys) {
  return operations.some(([, path]) => keys.has(path[0]));
}

export function subscribeToInfoGraphChanges(infos, keys, callback) {
  return subscribe(infos, (operations) => {
    if (includesInfoGraphChange(operations, keys)) callback();
  });
}
